export default "__VITE_ASSET__CwYeFL$7__"